import { Accordion } from "react-bootstrap"

import * as Scrivito from "scrivito"

import { AccordionWidget } from "./AccordionWidgetClass"

Scrivito.provideComponent(AccordionWidget, ({ widget }) => (
  <Accordion className="accordion-widget">
    <Scrivito.ContentTag content={widget} attribute="tabs" />
  </Accordion>
))
